import type {
  PROJECT_PREVIEW_DATA,
  PROJECT_PREVIEW_PARAMS,
  PROJECT_PREVIEW_PARAMS_DEVICE,
} from './types'
import { DEFAULT_MARGIN, DEFAULT_PADDING } from '@@/shared-components/content/const'
import { DEFAULT_BLOCK_LINK } from '../_shared/link/types'

export const DEFAULT_PROJECT_PREVIEW_DATA = (): PROJECT_PREVIEW_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'project-preview',
  heading: 'Jak obsah vypadá uvnitř?',
  ctaLabel: 'Náhled celé databáze',
  ctaLink: DEFAULT_BLOCK_LINK(),
})

const DEFAULT_PROJECT_PREVIEW_PARAMS_DEVICE = (): PROJECT_PREVIEW_PARAMS_DEVICE => ({
  hidden: false,
  accentColor: null,
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_PROJECT_PREVIEW_PARAMS = (): PROJECT_PREVIEW_PARAMS => ({
  pc: DEFAULT_PROJECT_PREVIEW_PARAMS_DEVICE(),
  tablet: DEFAULT_PROJECT_PREVIEW_PARAMS_DEVICE(),
  mobile: DEFAULT_PROJECT_PREVIEW_PARAMS_DEVICE(),
})
